export function getStepDescription(step: number) {
  switch (step) {
    case 2:
      return `We've prepopulated the last applied assignments for this crew. You can edit and assign a date range to apply below.`;
    default:
      return `You'll configure the assignments in the next step.`;
  }
}
